<div id="donor-card" data-cy="donor-card">
  <h1 *ngIf="!isModalPopup">Donor Card</h1>

  <div class="grid">
    <div class="col-12 xxl:col-8">
      <!-- Donor Tabbed Card -->
      <p-tabView styleClass="tabbed-card" (onChange)="switchTab($event)">
        <div class="flex align-items-center pl-5 py-2" *ngIf="generalInfo === null">
          <p-skeleton shape="circle" size="4rem" styleClass="mr-5" />
          <p-skeleton width="12rem" styleClass="mb-2" />
        </div>

        <div class="grid flex-nowrap justify-content-between mx-3" data-cy="donor-header" *ngIf="generalInfo != null">
          <!-- hiding on mobile to save space -->
          <div class="col hidden sm:flex align-items-center">
            <!-- Conditional -->
            <i *ngIf="isDonorTypeIndividual" class="fa-sharp fa-light fa-circle-user content-type-icon"></i>
            <i *ngIf="!isDonorTypeIndividual" class="fa-sharp fa-light fa-landmark content-type-icon"></i>
          </div>
          <div class="col flex align-items-center" style="flex-grow: 6;" data-cy="donor-info">
            <div>
              <p class="text-xl md:text-2xl font-bold red-60">
                {{ generalInfo.displayName }} 
                <span *ngIf="generalInfo.isDeceased" class="text-sm">[deceased]</span>
                <p-tag *ngIf="generalInfo.fundraiserId" severity="info" value="Fundraiser" /> </p>
              <p class="mb-0"><b>Donor ID: </b>{{ generalInfo.donorId }}</p>
              <p class="mb-0" *ngIf="generalInfo.spouseDonorId">
                <b>Spouse: </b>
                <a [href]="'/vortex/donors/card/'+ generalInfo.spouseDonorId"> 
                  {{ generalInfo.spouseName }}
                </a>
              </p>
            </div>
          </div>
          <div class="col flex align-items-center justify-content-end">
            <p-button styleClass="p-button-icon-teal-light button-card-edit mx-1"
                      icon="fa-sharp fa-light fa-pencil"
                      [rounded]="true"
                      (onClick)="editDonor()"
                      title="Edit"
                      data-cy="btn-edit-donor"
                      *ngIf="editStep >= 0" />

          </div>
        </div>
        
        <p-tabPanel header="Contact" data-cy="tab-contact">
          <hr class="divider-dashed mt-0 mb-5">

          <div class="grid mx-3">
            <div class="col-12 sm:col-6 py-2" *ngIf="generalInfo === null">
              <p-skeleton width="12rem" styleClass="mb-2" />
              <p-skeleton width="7rem" styleClass="mb-2" />
              <p-skeleton width="10rem" styleClass="mb-2" />
            </div>

            <div class="col-12 sm:col-6 py-2" *ngIf="generalInfo === null">
              <p-skeleton width="10rem" styleClass="mb-2" />
              <p-skeleton width="12rem" styleClass="mb-2" />
              <p-skeleton width="7rem" styleClass="mb-2" />
            </div>

            <div class="col-12 sm:col-6" *ngIf="generalInfo != null">
              <p *ngFor="let addr of this.addresses">
                <b>{{addr.addressType}} <span *ngIf="addr.isPrimaryString === 'Yes'"> - Primary</span></b><br />
                
                {{addr.address1 ? addr.address1 : 'N/A' }}  
                <br *ngIf="addr.address2">
                {{addr.address2}} <br />
                {{addr.city}}{{addr.city ? ', ' : ''}}
                {{addr.state}} {{addr.zipcode}}
              </p>
            </div>
            <div class="col-12 sm:col-6"  *ngIf="generalInfo != null">
              <p>
                <span *ngFor="let ph of this.phoneNumbers">
                  <b>{{ph.phoneType}}:</b> {{ph.donorPhoneNumber || 'N/A'}} <br />
                </span>
              </p>
              <p>
                <span *ngFor="let e of this.emailAddresses">
                  <b>{{e.emailType}} Email:</b> {{e.email}} <br />
                </span>
              </p>
            </div>
          </div>
        </p-tabPanel>        

        <p-tabPanel header="General" data-cy="tab-general">
          <hr class="divider-dashed mt-0 mb-5">
          
          <div class="grid mx-3" *ngIf="generalInfo != null">
            <div class="col-12 sm:col-6">
              <p>
                <b>Employer: </b>{{ generalInfo.employer ? generalInfo.employer : 'N/A' }} <br />
                <b>Occupation: </b>{{ generalInfo.occupation ? generalInfo.occupation : 'N/A'}}</p>
              <p><b>DOB: </b>{{ generalInfo.dateOfBirth ? this.sharedService.shortDate(generalInfo.dateOfBirth)  : 'N/A' }}</p>
              <p><b>Inception: </b> {{ generalInfo.inception }} </p>
            </div>
            <div class="col-12 sm:col-6">
              <p><b>Legacy ID: </b>{{ generalInfo.legacyRecordId ? generalInfo.legacyRecordId : 'N/A' }}</p>
              <p><b>FEC Candidate ID: </b> {{ generalInfo.fecCandidateId ? generalInfo.fecCandidateId : 'N/A' }}</p>
            </div>
          </div>
        </p-tabPanel>

        <p-tabPanel header="Relationships" data-cy="tab-relationships">
          <hr class="divider-dashed mt-0 mb-5">

          <div class="grid mx-3">
            <div class="col-12">
              <p-table [value]="donorRelationships"
                dataKey="id"
                styleClass="datatable-sm"
                [expandedRowKeys]="expandedRows"
                [scrollable]="true"
                scrollHeight="400px">

                <ng-template pTemplate="header">
                  <tr>
                    <th [attr.colspan]="6">Relationships</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-donorRelationshipItem let-expanded="expanded">
                  <tr>
                    <td>
                      <b>{{ donorRelationshipItem.relationshipTypeName }}</b><br/>
                      <a [href]="'/vortex/donors/card/'+ donorRelationshipItem.relatedDonorId">{{ donorRelationshipItem.relatedDisplayName }}</a></td>
                    <td>
                      <!-- [hidden]="!rs.isHousehold" -->
                      <span *ngIf="donorRelationshipItem.isHousehold">
                        <i class="fa-sharp fa-regular fa-house-circle-check same-household-yes" title="Same Household"></i>
                      </span>
                      <!--  [hidden]="rs.isHousehold" -->
                      <span *ngIf="!donorRelationshipItem.isHousehold">
                        <i class="fa-sharp fa-light fa-house same-household-no" title="Not Same Household"></i>
                      </span>
                    </td>
                    <td>
                      <rc-generic-button label="Delete" iconImg="trash" iconColor="red-light" [isIconOnly]="true" [classes]="['table-action-btn']" data-cy="btn-delete" />
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" *ngIf="donorRelationships.length==0">
                  <tr>
                    <td [attr.colspan]="6" style="text-align: center;">
                      There are no relationships for this donor.
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-tabPanel>

        <p-tabPanel header="Donor Letters" data-cy="tab-letters">
          <hr class="divider-dashed mt-0 mb-5">
          <app-donor-letters
            [donorId]="this.donorId"
            [campaignId]="this.campaignId">

          </app-donor-letters>
        </p-tabPanel>
        
        <p-tabPanel header="Notes" data-cy="tab-notes">
          <hr class="divider-dashed mt-0 mb-5">
          <app-donor-notes
              [campaignId]="campaignId"
              [donorId]="donorId">
          </app-donor-notes>
        </p-tabPanel>

        <p-tabPanel header="Donor Flags" data-cy="tab-flags">
          <hr class="divider-dashed mt-0 mb-5" />
          <div class="col-12">
            <p-table 
              [value]="donorFlags" 
              dataKey="id" 
              styleClass="datatable-sm"
              [expandedRowKeys]="expandedRows" 
              [scrollable]="true" 
              scrollHeight="400px">

              <ng-template pTemplate="header">
                <tr>
                  <th>Donor Flags</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-donorFlagItem let-expanded="expanded">
                <tr>
                  <td style="text-align: left;">{{ donorFlagItem.name }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" *ngIf="donorFlags.length==0">
                <tr>
                  <td style="text-align: center;">
                    There are no donor flags found for this donor
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </p-tabPanel>

        <p-tabPanel header="Salutation" data-cy="tab-salutation">
          <hr class="divider-dashed mt-0 mb-5">
          <div class="grid mx-3">
            <div class="col-12 sm:col-6">
              <p><b>Informal: </b>{{donorSalutations?.informalName ? donorSalutations?.informalName : 'N/A'}}</p>
              <p><b>Formal: </b>{{donorSalutations?.formalSalutation ? donorSalutations?.formalSalutation : 'N/A'}}</p>
              <p><b>Mail: </b>{{donorSalutations?.mailSalutation ? donorSalutations?.mailSalutation : 'N/A'}}</p>
            </div>
          </div>
        </p-tabPanel>

        <p-tabPanel header="Suppressions" data-cy="tab-Suppressions">
          <hr class="divider-dashed mt-0 mb-5">
          <div class="grid mx-3">
            <div class="col supression-wrapper">

              <div [ngClass]="{'supression-true': donorSuppression.doNotSolicit, 'supression-false': !donorSuppression.doNotSolicit}">Do Not Solicit</div>
              <div [ngClass]="{'supression-true': donorSuppression.doNotEmail, 'supression-false': !donorSuppression.doNotEmail}">Do Not Email</div>
              <div [ngClass]="{'supression-true': donorSuppression.doNotMail, 'supression-false': !donorSuppression.doNotMail}">Do Not Mail</div>
              <div [ngClass]="{'supression-true': donorSuppression.doNotCall, 'supression-false': !donorSuppression.doNotCall}">Do Not Call</div>
              <div [ngClass]="{'supression-true': donorSuppression.isDeceased, 'supression-false': !donorSuppression.isDeceased}">Is Deceased</div>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>

    <div class="col-12 md:col-6 xxl:col-4">
      <app-donor-lifetime-history [fundcodesHistory]="fundcodesHistory" data-cy="card-lifetime-history"></app-donor-lifetime-history>

    </div>
  
    <div class="col-12 md:col-6 xxl:col-6">
      <app-current-cycle-donations [campaignId]="this.campaignId" [donorId]="this.donorId" data-cy="card-current-cycle"></app-current-cycle-donations>
    </div>

    <div class="col-12 xxl:col-6">

      <p-card styleClass="card-style-donor" data-cy="card-fund-totals">
        <ng-template pTemplate="header">
          <p>Fund Totals</p>
          <!-- <p-button icon="pi pi-window-maximize"
                    [text]="true"
                    title="Expand" /> -->
        </ng-template>
        <div class="grid">
          <div class="col-12">
            <app-donor-fund-totals-grid [donorId]="this.donorId.toString()" (fundcodesHistoryLoaded)="onFundcodesHistoryLoaded($event)">
            </app-donor-fund-totals-grid>
          </div>
        </div>
      </p-card>

    </div>

    <div class="col-12">
      <p-card styleClass="card-style-donor" data-cy="card-donations">
        <ng-template pTemplate="header">
          <p>Donations</p>
        </ng-template>

        <div>
          <app-donor-donations [donorId]="donorId" [campaignId]="campaignId"></app-donor-donations>
        </div>
      </p-card>
    </div>

  </div>
</div>

<!-- Edit Donor MODAL -->
<div id="edit-donor-card" data-cy="edit-donor-card">
  <p-dialog [(visible)]="isDonorEditSidebarVisible"
    header="Edit Donor" 
    [modal]="true"
    [maximizable]="true"
    styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300" >

    <div>
      <div ngClass="medium loader-wrapper" *ngIf="isDonorEditDataLoading">
        <rc-loading-spinner></rc-loading-spinner>
      </div>

      <app-donor-add  
          [donorToEdit]="donorToEdit"
          [isEditMode]="true"
          [activeStep]="editStep"
          *ngIf="!isDonorEditDataLoading"
          (cancel) = "closeModal()">
      </app-donor-add>
    </div>

  </p-dialog>
</div>




